const initOrderHistoryScrollIndicator = () => {
  const orderHistory = document.querySelector('#order-history');

  if (orderHistory) {
    const scrollContainer = orderHistory.querySelector('.block-container');
    const contentText = orderHistory.querySelector('.section-content-text');

    if (scrollContainer && contentText) {
      const handleScroll = () => {
        const scrollLeft = scrollContainer.scrollLeft;
        const isAtStart = scrollLeft <= 5;

        if (isAtStart) {
          contentText.classList.remove('scrolling');
        } else {
          contentText.classList.add('scrolling');
        }
      };

      scrollContainer.addEventListener('scroll', handleScroll);
    }
  }

  const productFeatureBoxes = document.querySelector('.shopify-section-main-product .product-info-feature-boxes');

  if (productFeatureBoxes) {
    const scrollContainer = productFeatureBoxes.querySelector('.flex');

    if (scrollContainer) {
      const handleScroll = () => {
        const scrollLeft = scrollContainer.scrollLeft;
        const isAtStart = scrollLeft <= 5;
        const isAtEnd = scrollLeft + scrollContainer.clientWidth >= scrollContainer.scrollWidth - 5;

        if (isAtStart) {
          productFeatureBoxes.classList.remove('scrolling');
        } else {
          productFeatureBoxes.classList.add('scrolling');
        }

        if (isAtEnd) {
          productFeatureBoxes.classList.add('at-end');
        } else {
          productFeatureBoxes.classList.remove('at-end');
        }
      };

      scrollContainer.addEventListener('scroll', handleScroll);
      handleScroll();
    }
  }
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initOrderHistoryScrollIndicator);
} else {
  initOrderHistoryScrollIndicator();
}
